import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatDisplayShortAddress, formatDisplayAddress } from '../../../../core/util/location';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { isEmptyString } from '../../../../core/util/string';

const VERBOSE = 'verbose';
const SHORT = 'short';
export const ADDRESS_FORMAT = { VERBOSE, SHORT };

const Root = styled.div`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  -webkit-font-smoothing: antialiased;
  line-height: 21px;
`;

class ClinicAddress extends PureComponent {
  render = () => {
    const {
      type,
      location: { subpremise, address, displayAddress, city, state, zipCode },
      className,
      shouldAddSchema,
    } = this.props;
    const streetAddress =
      `${!isEmptyString(displayAddress) ? displayAddress : address}` +
      `${subpremise ? `, ${subpremise}` : ''}`;

    return (
      <Root
        itemProp={shouldAddSchema ? 'address' : undefined}
        itemType={shouldAddSchema ? 'https://schema.org/PostalAddress' : undefined}
        itemScope={shouldAddSchema}
        className={className}
      >
        {type === VERBOSE && (
          <span>
            <span itemProp={shouldAddSchema ? 'streetAddress' : undefined}>{streetAddress}</span>,{' '}
            <span itemProp={shouldAddSchema ? 'addressLocality' : undefined}>{city}</span>,{' '}
            <span itemProp={shouldAddSchema ? 'addressRegion' : undefined}>{state}</span>,{' '}
            <span itemProp={shouldAddSchema ? 'postalCode' : undefined}>{zipCode}</span>
          </span>
        )}
        {type === SHORT && (
          <span>
            <span itemProp={shouldAddSchema ? 'streetAddress' : undefined}>{streetAddress}</span>,{' '}
            <span itemProp={shouldAddSchema ? 'addressLocality' : undefined}>{city}</span>{' '}
          </span>
        )}
      </Root>
    );
  };
}

ClinicAddress.propTypes = {
  location: PropTypes.object.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  shouldAddSchema: PropTypes.bool,
};

ClinicAddress.defaultProps = {
  type: VERBOSE,
  shouldAddSchema: true,
};

export default ClinicAddress;
